// src/pages/ReactionsTestPage.tsx
import React, { useState } from 'react';
import { FacebookSelector, FacebookCounter } from '../components/Reactions/Reactions';

// Sample reaction data
const sampleCounters = [
  { emoji: 'like', by: 'John Doe' },
  { emoji: 'like', by: 'Jane Smith' },
  { emoji: 'love', by: 'Alice Johnson' },
  { emoji: 'haha', by: 'Bob Williams' },
  { emoji: 'wow', by: 'Charlie Brown' },
  { emoji: 'love', by: 'Diana Ross' },
];

const ReactionsTestPage: React.FC = () =>
{
  const [selectedReaction, setSelectedReaction] = useState<string | null>(null);
  const [counters, setCounters] = useState(sampleCounters);
  const [showSelector, setShowSelector] = useState(false);

  const handleReactionSelect = (reaction: string) =>
  {
    setSelectedReaction(reaction);
    // Add the reaction to counters
    setCounters(prev => [...prev, { emoji: reaction, by: 'Current User' }]);
    setShowSelector(false);
  };

  const handleCounterClick = () => {};

  const resetCounters = () =>
  {
    setCounters(sampleCounters);
    setSelectedReaction(null);
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1 style={{ marginBottom: '20px' }}>Reactions Component Test</h1>

      {/* FacebookSelector Section */}
      <section
        style={{
          marginBottom: '40px',
          padding: '20px',
          border: '1px solid #ddd',
          borderRadius: '8px',
          backgroundColor: 'white',
        }}
      >
        <h2 style={{ marginBottom: '15px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
          FacebookSelector
        </h2>

        <div style={{ marginBottom: '20px' }}>
          <button
            onClick={() => setShowSelector(!showSelector)}
            style={{
              padding: '10px 20px',
              backgroundColor: '#1877f2',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
            }}
          >
            {showSelector ? 'Hide Selector' : 'Show Reaction Selector'}
          </button>
        </div>

        {showSelector && (
          <div style={{ marginBottom: '20px' }}>
            <FacebookSelector
              reactions={['like', 'love', 'haha', 'wow', 'sad', 'angry']}
              iconsize={40}
              onselect={handleReactionSelect}
            />
          </div>
        )}

        {selectedReaction && (
          <div
            style={{
              padding: '10px',
              backgroundColor: '#e7f3ff',
              borderRadius: '4px',
              marginTop: '10px',
            }}
          >
            <strong>Last selected reaction:</strong> {selectedReaction}
          </div>
        )}
      </section>

      {/* FacebookCounter Section */}
      <section
        style={{
          marginBottom: '40px',
          padding: '20px',
          border: '1px solid #ddd',
          borderRadius: '8px',
          backgroundColor: 'white',
        }}
      >
        <h2 style={{ marginBottom: '15px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
          FacebookCounter
        </h2>

        <div style={{ marginBottom: '20px' }}>
          <h3 style={{ marginBottom: '10px', fontSize: '14px', color: '#666' }}>
            Counter with labels:
          </h3>
          <div
            style={{
              display: 'inline-block',
              backgroundColor: '#f5f5f5',
              padding: '10px',
              borderRadius: '6px',
            }}
          >
            <FacebookCounter
              id="test-counter-1"
              counters={counters}
              user="Current User"
              important={['John Doe', 'Jane Smith']}
              onclick={handleCounterClick}
              includeLabel={true}
            />
          </div>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h3 style={{ marginBottom: '10px', fontSize: '14px', color: '#666' }}>
            Counter without labels (just count):
          </h3>
          <div
            style={{
              display: 'inline-block',
              backgroundColor: '#f5f5f5',
              padding: '10px',
              borderRadius: '6px',
            }}
          >
            <FacebookCounter
              id="test-counter-2"
              counters={counters}
              user="Current User"
              onclick={handleCounterClick}
              includeLabel={false}
            />
          </div>
        </div>

        <button
          onClick={resetCounters}
          style={{
            padding: '8px 16px',
            backgroundColor: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px',
          }}
        >
          Reset Reactions
        </button>
      </section>

      {/* Custom Configuration Section */}
      <section
        style={{
          marginBottom: '40px',
          padding: '20px',
          border: '1px solid #ddd',
          borderRadius: '8px',
          backgroundColor: 'white',
        }}
      >
        <h2 style={{ marginBottom: '15px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
          Custom Configurations
        </h2>

        <div style={{ marginBottom: '20px' }}>
          <h3 style={{ marginBottom: '10px', fontSize: '14px', color: '#666' }}>
            Different icon sizes:
          </h3>
          <div style={{ display: 'flex', gap: '20px', flexDirection: 'column' }}>
            <div>
              <span style={{ marginRight: '10px', fontSize: '12px', color: '#888' }}>
                Small (24px):
              </span>
              <FacebookSelector iconsize={24} onselect={handleReactionSelect} />
            </div>
            <div>
              <span style={{ marginRight: '10px', fontSize: '12px', color: '#888' }}>
                Medium (38px):
              </span>
              <FacebookSelector iconsize={38} onselect={handleReactionSelect} />
            </div>
            <div>
              <span style={{ marginRight: '10px', fontSize: '12px', color: '#888' }}>
                Large (52px):
              </span>
              <FacebookSelector iconsize={52} onselect={handleReactionSelect} />
            </div>
          </div>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h3 style={{ marginBottom: '10px', fontSize: '14px', color: '#666' }}>
            Custom background:
          </h3>
          <div
            style={{
              display: 'inline-block',
              padding: '10px',
              backgroundColor: '#333',
              borderRadius: '8px',
            }}
          >
            <FacebookSelector iconsize={38} bg="#333" onselect={handleReactionSelect} />
          </div>
        </div>
      </section>

      {/* Debug Info */}
      <details style={{ marginTop: '20px' }}>
        <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>
          Debug: Current Reactions Data
        </summary>
        <pre
          style={{
            backgroundColor: '#f8f9fa',
            padding: '15px',
            borderRadius: '4px',
            overflow: 'auto',
            maxHeight: '300px',
            fontSize: '12px',
          }}
        >
          {JSON.stringify(counters, null, 2)}
        </pre>
      </details>
    </div>
  );
};

export default ReactionsTestPage;
